export default __webpack_public_path__ + "static/media/instructions-start-of-play.d13975ef.png";